// src/components/home/VideoTestimonialsSection.jsx
import React, { useRef, useEffect, useState } from 'react';
import { X, Play } from 'lucide-react';

const videos = [
  { id: 1, vimeoId: '1213828836', title: 'IMG_7972', zoom: 1.1, focusY: -4 },
  { id: 2, vimeoId: '1213828837', title: 'IMG_7973' },
  { id: 3, vimeoId: '1213828838', title: 'IMG_7971' },
  { id: 4, vimeoId: '1213828839', title: 'IMG_7974' },
  { id: 5, vimeoId: '1218207897', title: 'IMG_7975' },
];

const VideoCard = ({ video, onOpen }) => {
  const iframeRef = useRef(null);

  const postToVimeo = (method, value) => {
    iframeRef.current?.contentWindow?.postMessage(
      JSON.stringify(value !== undefined ? { method, value } : { method }),
      'https://player.vimeo.com'
    );
  };

  useEffect(() => {
    const handleMessage = (e) => {
      if (e.origin !== 'https://player.vimeo.com') return;
      try {
        const data = JSON.parse(e.data);
        if (data.event === 'ready') {
          // Start muted so nothing plays before the user hovers
          postToVimeo('setVolume', 0);
        }
      } catch {
        // ignore non-JSON messages from other sources
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const handleMouseEnter = () => {
    // mouseenter is a real user gesture, so unmuted play is allowed here
    postToVimeo('setVolume', 1);
    postToVimeo('play');
  };

  const handleMouseLeave = () => {
    postToVimeo('pause');
    postToVimeo('setVolume', 0);
  };

  return (
    <div
      className="group relative rounded-xl overflow-hidden shadow-md bg-black 
                 aspect-[9/16] cursor-pointer transition-transform duration-300 hover:scale-[1.02]"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={() => onOpen(video)}
    >
      <iframe
        ref={iframeRef}
        src={`https://player.vimeo.com/video/${video.vimeoId}?title=0&byline=0&portrait=0&controls=0`}
        className="w-full h-full pointer-events-none"
        style={{
          transform: `scale(${video.zoom || 1}) translateY(${video.focusY || 0}%)`,
          transformOrigin: 'center center',
        }}
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        title={video.title}
      ></iframe>

      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
        <div className="bg-white/90 rounded-full p-3">
          <Play className="w-6 h-6 text-black" fill="black" />
        </div>
      </div>
    </div>
  );
};

const VideoTestimonialsSection = () => {
  const [activeVideo, setActiveVideo] = useState(null);
  const closeModal = () => setActiveVideo(null);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') closeModal();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  return (
  <section className="py-12 bg-[#E4DED5]">
      <div className="max-w-7xl mx-auto px-4">
 <div className="text-center mb-10 sm:mb-14 px-2">
  <h2 className="text-[black] text-3xl sm:text-4xl md:text-5xl font-playfair font-semibold mt-4 sm:mt-5 mb-2">
    Client Reviews
  </h2>
  <p className="text-[#4b4b4b] text-sm sm:text-base md:text-lg px-2">
    Hear directly from our clients
  </p>
</div>

<div className="grid grid-cols-2 sm:grid-cols-5 gap-5">
          {videos.map((video) => (
            <VideoCard key={video.id} video={video} onOpen={setActiveVideo} />
          ))}
        </div>
      </div>

      {activeVideo && (
        <div
          className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <div
            className="relative w-full max-w-md"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              className="absolute -top-10 right-0 text-white hover:text-gray-300"
              aria-label="Close"
            >
              <X className="w-8 h-8" />
            </button>
            <div className="rounded-xl overflow-hidden shadow-2xl bg-black aspect-[9/16]">
              <iframe
                src={`https://player.vimeo.com/video/${activeVideo.vimeoId}?title=0&byline=0&portrait=0&autoplay=1`}
                className="w-full h-full"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title={activeVideo.title}
              ></iframe>
            </div>
            <p className="text-white text-center mt-4 text-lg font-medium">
              {activeVideo.title}
            </p>
          </div>
        </div>
      )}
    </section>
  );
};

export default VideoTestimonialsSection;